import moment from "moment";

export const formatarData = (data: any) => {
  return moment(new Date(data), "DD/MM/YYYY").format("DD/MM/YYYY");
};

export const formatarDataHora = (data: any) => {
  return moment(new Date(data), "DD/MM/YYYY HH:mm:ss").format(
    "DD/MM/YYYY HH:mm:ss"
  );
};

export const formatarDataBanco = (data: any) => {
  return moment(new Date(data), "YYYY-MM-DD").format("YYYY-MM-DD");
};
